import 'react-app-polyfill/ie11';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import './base.css';

import { AppHeader, AppFooter } from '@/components'
import Home from '@/containers/Home';
import Investor from '@/containers/Investor';//投资者关系
import ContactUs from '@/containers/ContactUs';//联系我们
import Feedback from '@/containers/Feedback';//投诉和建议
import Cooperation from '@/containers/Join/Cooperation'//商务合作
import Recruit from '@/containers/Join/Recruit'//工作机会
import CampusRecruiting from '@/containers/Join/CampusRecruiting'//校园招聘宣传
import CompanyProfile from '@/containers/Introduction/CompanyProfile'
import Ecology from '@/containers/Introduction/Ecology'
import QualificationAndHonor from '@/containers/Introduction/QualificationAndHonor'
import NewsDetail from '@/containers/News/NewsDetail'//详情->公司动态
// import EngineeringDesign from '@/containers/Products/ProductDetails/EngineeringDesign'//工程设计
import News from '@/containers/News'
import ProductDetails from '@/containers/Products/ProductDetails/index'//工程设计
import World from '@/containers/Products/World/index'//工程设计
import EcosphereDetails from '@/containers/Products/EcosphereDetails/index'//BIM
// import BIM from '@/containers/Products/EcosphereDetails/BIM'
import * as serviceWorker from './serviceWorker';

class mainPage extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      includeHeaderPath: ['/', '/ContactUs', '/Feedback', '/Join/Cooperation', '/Join/Recruit', '/Introduction/CompanyProfile', '/Introduction/Ecology', '/Introduction/QualificationAndHonor'],
      includeFooterPath: ['/', '/ContactUs', '/Feedback', '/Join/Cooperation', '/Join/Recruit', '/Introduction/CompanyProfile', '/Introduction/Ecology', '/Introduction/QualificationAndHonor'],
    }
  }
  componentWillUpdate() {
    window.scrollTo(0, 0)
    const domNode = document.getElementById('root');
    if (this.props.history.location.pathname === '/') {
      domNode.className = "index-gray"
    } else {
      domNode.className = ""
    }
  }
  componentDidMount() {
    const domNode = document.getElementById('root');
    if (this.props.history.location.pathname === '/') {
      domNode.className = "index-gray"
    } else {
      domNode.className = ""
    }
  }
  render() {
    return (
      <React.Fragment>
        {
          this.state.includeHeaderPath.includes(window.location.pathname) && <Route component={AppHeader} />
        }
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/Investor" component={Investor} />
          <Route exact path="/ContactUs" component={ContactUs} />
          <Route exact path="/Feedback" component={Feedback} />
          <Route exact path="/Join/Cooperation" component={Cooperation} />
          <Route exact path="/Join/Recruit" component={Recruit} />
          <Route exact path="/Join/CampusRecruiting" component={CampusRecruiting} />
          <Route exact path="/Introduction/Ecology" component={Ecology} />
          <Route exact path="/Introduction/CompanyProfile" component={CompanyProfile} />
          <Route exact path="/Introduction/QualificationAndHonor" component={QualificationAndHonor} />
          <Route exact path="/News/:id" component={News} />
          <Route exact path="/Introduction/:id" component={News} />
          <Route exact path="/:baseName/:pageName/NewsDetail/:id" component={NewsDetail} />
          <Route path="/Products/ProductDetails/:id" component={ProductDetails} />
          <Route path="/Products/EcosphereDetails/:id" component={EcosphereDetails} />
          <Route path="/Products/World/:id" component={World} />
          <Route component={() => (<Redirect to='/' />)} />
        </Switch>
        {
          this.state.includeFooterPath.includes(window.location.pathname) && <Route component={AppFooter} />
        }
      </React.Fragment>
    )
  }
}

class App extends React.PureComponent {
  render() {
    return (
      <Router>
        <Route component={mainPage} />
      </Router>
    )
  }
}

if (process.env.REACT_APP_API !== 'http://website.tzecc.com/api/') {
  //百度统计
  (function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?b0ad3904038dbb57adcc94e4cb60a30d";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
}
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
